import { createFileRoute } from '@tanstack/react-router';

import { BillingTab } from '@/components/settings/billing/billing-tab';

export const Route = createFileRoute('/_authenticated/settings/billing')({
  staticData: {
    title: 'route.settings_billing.title',
  },
  component: BillingTab,
});
